import { ProductDetailsModel } from '@data-layer/models/common';

// #13213 — POA price is displayed from the backend product config (GET /api/v2/product-details).
// The price line is hidden until a price fetched for the SAME company is available.
// #13318 — a company that is not created yet (companyId null) matches the entry fetched without
// a company: that price is resolved from the organization, so the organization must match too.
export class PoaPriceHelper {
  public static extractPrice(
    details: ProductDetailsModel | null,
    companyId: number | null,
    organizationId: number | null = null,
  ): number | null {
    if (details === null || !PoaPriceHelper.isSameContext(details, companyId, organizationId)) {
      return null;
    }
    return details.product.fixedPrice ?? null;
  }

  // #13318 — a cached price belongs to the company it was fetched for; without a company it
  // belongs to the organization instead (the backend ignores organizationId once a company is given)
  public static isSameContext(details: ProductDetailsModel, companyId: number | null, organizationId: number | null): boolean {
    if ((details.companyId ?? null) !== companyId) {
      return false;
    }
    return companyId !== null || (details.organizationId ?? null) === organizationId;
  }

  // fixedPrice is a double on the backend: whole amounts render without decimals ("$30"),
  // fractional ones with exactly two ("$14.90")
  public static formatPrice(price: number): string {
    return Number.isInteger(price) ? String(price) : price.toFixed(2);
  }
}
